var _defs, _rect, _polygon, _polygon2, _polygon3, _polygon4, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCad(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 217 217",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#a80000;stroke:#e30000;stroke-miterlimit:10;stroke-width:7px;}.cls-2{fill:#ce0000;}.cls-3{fill:#fff;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "tile icon CDA") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 3.5,
    y: 3.5,
    width: 210,
    height: 210,
    rx: 23.6
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "111.54 187.3 200.39 36.56 80.84 53.27 159.92 69.98 111.54 187.3"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "148.41 78.14 104.23 187.3 16.61 38.79 94.21 136.8 148.41 78.14"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "94.21 124.18 19.21 28.77 192.96 28.77 68.96 46.59 94.21 124.18"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "83.69 61.75 99.28 120.41 141.85 76.47 83.69 61.75"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M89.76,156.85c-5.13,16.05-17.85,23.39-35.83,23.39-19.48,0-29.19-10.56-29.19-27.23,0-17.6,11.05-41.69,40.81-41.69,18.86,0,28.9,9.23,28.8,23.27H73.72c0-4.92-1.63-9.84-9.79-9.84-12.2,0-17.84,17.84-17.84,29.18,0,7.23,2.38,12.78,9.94,12.78,7.23,0,10.56-4.37,13-9.86Z",
    transform: "translate(-1.23 -1.5)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M109.28,169.26l-5,9.74H89.31l26.59-46.94h18.81L140.08,179H125.66l-.92-9.74Zm15.29-9.71c-.68-7.14-1.14-13.85-1.29-18.19h-.21c-2.29,5.15-5.55,11.43-9.13,18.19Z",
    transform: "translate(-1.23 -1.5)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M156.33,132.06h18.76c14.39,0,22.72,7.7,22.72,19.9,0,13.53-8.91,27-30.45,27h-22Zm5.61,37.53h6.24c9.31,0,14.56-8.57,14.56-18.05,0-6.8-3.17-10.06-9.42-10.06h-4.81Z",
    transform: "translate(-1.23 -1.5)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCad);
export default __webpack_public_path__ + "static/media/icon-CAD.189a5d8b2f758414d5816b0385d8f9af.svg";
export { ForwardRef as ReactComponent };